import { Sparkles } from "lucide-react";

const GoogleIcon = () => (
  <svg viewBox="0 0 48 48" className="w-5 h-5"><path fill="#FFC107" d="M43.6 20.5H42V20H24v8h11.3C33.7 32.7 29.2 36 24 36c-6.6 0-12-5.4-12-12s5.4-12 12-12c3.1 0 5.8 1.2 7.9 3.1l5.7-5.7C34 6.1 29.3 4 24 4 12.9 4 4 12.9 4 24s8.9 20 20 20 20-8.9 20-20c0-1.3-.1-2.4-.4-3.5z" /><path fill="#FF3D00" d="M6.3 14.7l6.6 4.8C14.7 15.1 19 12 24 12c3.1 0 5.8 1.2 7.9 3.1l5.7-5.7C34 6.1 29.3 4 24 4 16.3 4 9.7 8.3 6.3 14.7z" /><path fill="#4CAF50" d="M24 44c5.2 0 9.9-2 13.4-5.2l-6.2-5.2C29.2 35.1 26.7 36 24 36c-5.2 0-9.6-3.3-11.3-7.9l-6.5 5C9.5 39.6 16.2 44 24 44z" /><path fill="#1976D2" d="M43.6 20.5H42V20H24v8h11.3c-.8 2.2-2.2 4.2-4.1 5.6l6.2 5.2C37 39.2 44 34 44 24c0-1.3-.1-2.4-.4-3.5z" /></svg>
);

const Shell = ({ children, title, sub }) => (
  <div className="min-h-screen grid lg:grid-cols-2">
    <div className="hidden lg:flex flex-col justify-between p-12 border-r border-[var(--c-line)] bg-[var(--c-surface)] relative overflow-hidden">
      <div className="flex items-center gap-2">
        <div className="w-9 h-9 rounded-xl bg-[var(--c-orange)] flex items-center justify-center glow-orange"><Sparkles className="w-5 h-5 text-white" /></div>
        <span className="font-display font-bold text-lg">Dainuok<span className="text-[var(--c-orange)]">.ai</span></span>
      </div>
      <div>
        <h2 className="font-display text-5xl font-bold leading-[1.05]">Lietuviškos dainos<br /><span className="text-zinc-500">su AI vokalu.</span></h2>
        <div className="flag-line h-[3px] w-24 mt-6 rounded-full" />
      </div>
      <p className="text-sm text-zinc-500">Kurk, perdainuok, dalinkis.</p>
    </div>
    <div className="flex items-center justify-center p-6 sm:p-12">
      <div className="w-full max-w-md space-y-8 rise">
        <div>
          <h1 className="font-display text-4xl font-bold">{title}</h1>
          <p className="text-zinc-400 mt-2">{sub}</p>
        </div>
        {children}
      </div>
    </div>
  </div>
);

const googleLogin = () => {
  // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
  const redirectUrl = window.location.origin + "/";
  window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
};

const GoogleButton = () => (
  <button data-testid="google-login-button" onClick={googleLogin}
    className="w-full flex items-center justify-center gap-3 py-3.5 rounded-full bg-white text-black font-semibold hover:bg-zinc-200 transition-colors">
    <GoogleIcon />Tęsti su Google
  </button>
);

export default function Login() {
  return (
    <Shell title="Prisijunk" sub="Svetainė skirta tik jos savininkui. Prisijunkite savo Google paskyra.">
      <GoogleButton />
      <p data-testid="login-owner-note" className="text-xs text-zinc-500 text-center">Kitos paskyros prieigos neturi.</p>
    </Shell>
  );
}
